var _rect, _g, _rect2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideocamGreen = function SvgVideocamGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18524_22231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18524_22231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36589 17.1576C2.90755 17.1576 2.51519 16.9944 2.1888 16.668C1.86241 16.3416 1.69922 15.9492 1.69922 15.4909V5.49089C1.69922 5.03255 1.86241 4.64019 2.1888 4.3138C2.51519 3.98741 2.90755 3.82422 3.36589 3.82422H13.3659C13.8242 3.82422 14.2166 3.98741 14.543 4.3138C14.8694 4.64019 15.0326 5.03255 15.0326 5.49089V9.24089L17.6576 6.61589C17.7964 6.477 17.9492 6.44227 18.1159 6.51172C18.2826 6.58116 18.3659 6.71311 18.3659 6.90755V14.0742C18.3659 14.2687 18.2826 14.4006 18.1159 14.4701C17.9492 14.5395 17.7964 14.5048 17.6576 14.3659L15.0326 11.7409V15.4909C15.0326 15.9492 14.8694 16.3416 14.543 16.668C14.2166 16.9944 13.8242 17.1576 13.3659 17.1576H3.36589Z",
    fill: "#38A169"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18524_22231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 11,
    height: 11
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.33081,
    y: 5.5,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18524_22231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71631 13.9694C7.65381 13.9486 7.60173 13.9121 7.56006 13.86C7.51839 13.8079 7.49756 13.7437 7.49756 13.6673V11.334H7.08089C6.85173 11.334 6.65554 11.2524 6.49235 11.0892C6.32916 10.926 6.24756 10.7298 6.24756 10.5007V7.16732C6.24756 6.93815 6.32916 6.74197 6.49235 6.57878C6.65554 6.41558 6.85173 6.33398 7.08089 6.33398H9.51839C9.74061 6.33398 9.91943 6.42079 10.0549 6.5944C10.1903 6.76801 10.2302 6.95898 10.1746 7.16732L9.58089 9.25065H10.0496C10.2996 9.25065 10.4854 9.36176 10.6069 9.58398C10.7285 9.80621 10.7163 10.0215 10.5705 10.2298L8.07048 13.8444C8.02881 13.9069 7.97499 13.9486 7.90902 13.9694C7.84304 13.9902 7.77881 13.9902 7.71631 13.9694Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideocamGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Videocam-green.0fba9376.svg";
export { ForwardRef as ReactComponent };